module.exports = __webpack_public_path__ + "img/2.ce272259.jpg";